// What HubPilot works with. Keep in step with the firmware guide and the HubPanel warning.
export const HUBS = [
  {
    id: "prime-original",
    name: "LEGO Education SPIKE Prime Hub",
    detail: "Original electronics · 2020–2025 · set 45678",
    status: "setup",
    notes: [
      "Install the free Pybricks firmware once from code.pybricks.com with the hub's USB cable (about 5 minutes).",
      "Windows only: set up the WinUSB driver the first time (once per computer).",
      "Needs Pybricks v3.3 or newer. Hubs with HubPilot firmware need the official Pybricks firmware installed instead.",
    ],
  },
  {
    id: "prime-2026",
    name: "LEGO Education SPIKE Prime Hub",
    detail: "New electronics · sold from 2026",
    status: "setup",
    notes: [
      "Install Pybricks firmware v4.1 or newer, which added these hubs.",
      "Use the latest installer at code.pybricks.com. If it doesn't list your hub, close every Pybricks tab and open it again.",
      "Update mode uses a different button combination. Follow the installer's on-screen steps.",
      "Support for these hubs is new. Please tell us if anything misbehaves.",
    ],
  },
  {
    id: "inventor",
    name: "LEGO MINDSTORMS Robot Inventor Hub",
    detail: "Set 51515",
    status: "setup",
    notes: [
      "Same electronics as the original SPIKE Prime hub, so it works exactly the same way.",
      "Install Pybricks firmware once, the same way as a SPIKE Prime hub.",
      "Robot setups made for SPIKE Prime work unchanged.",
    ],
  },
];

export const HUBS_TIP = "Not sure which SPIKE Prime hub you have? You don't need to know: the Pybricks installer handles both.";

export const HUBS_NOT = [
  { name: "Any hub still running LEGO firmware (SPIKE App or MINDSTORMS app)", why: "LEGO's firmware can't pair with a game controller. Install Pybricks firmware first. You can put LEGO's back any time." },
  { name: "Hubs running HubPilot or HubSync firmware", why: "No longer supported. Install the official Pybricks firmware from code.pybricks.com." },
  { name: "SPIKE Essential Hub (45609)", why: "Not yet. HubPilot setups are made for the 6-port Prime hub." },
  { name: "Technic Hub (88012), City Hub (88009), BOOST Move Hub (88006)", why: "Not supported. HubPilot is made for SPIKE Prime hubs." },
  { name: "MINDSTORMS EV3, NXT and WeDo 2.0", why: "Not supported. These are different systems that HubPilot doesn't work with." },
];

const UPDATE_NOTES = [
  "Needs Microsoft's controller update that adds Bluetooth LE (from 2021). Do it once per controller.",
  "Update with the free Xbox Accessories app on Windows (USB cable) or on an Xbox console.",
];

export const CONTROLLERS = [
  {
    id: "series",
    name: "Xbox Wireless Controller (Series X|S)",
    detail: "Model 1914 · 2020 onwards",
    status: "works",
    notes: ["Has Bluetooth LE built in, so it works straight away.", "If it won't connect, update it with the Xbox Accessories app."],
  },
  { id: "one-s", name: "Xbox Wireless Controller (Xbox One S style)", detail: "Model 1708 · 2016 onwards", status: "setup", notes: UPDATE_NOTES },
  { id: "elite2", name: "Xbox Elite Wireless Controller Series 2 (and Core)", detail: "Model 1797", status: "setup", notes: UPDATE_NOTES },
];

export const CONTROLLERS_TIP = "The model number is printed inside the battery compartment. Each hub pairs with one controller at a time.";

export const CONTROLLERS_NOT = [
  { name: "Original Xbox One controllers (models 1537, 1697) and the first Elite (model 1698)", why: "No Bluetooth, so the hub can't see them." },
  { name: "Xbox 360 controllers", why: "No Bluetooth." },
  { name: "PlayStation (DualShock 4, DualSense) and Nintendo Switch controllers", why: "The hub firmware only understands Xbox controllers." },
  { name: "Third-party \"Xbox-style\" controllers", why: "Not supported. HubPilot only works with Microsoft-made Xbox controllers." },
  { name: "LEGO Powered Up Remote (88010)", why: "Not yet. It's on our list." },
];

// yes | no | setting (works after turning on a browser setting)
export const BROWSERS = [
  { id: "chrome", name: "Google Chrome", platforms: "Windows 10/11, macOS, ChromeOS", code: "yes", connect: "yes", firmware: "yes" },
  { id: "edge", name: "Microsoft Edge", platforms: "Windows 10/11, macOS", code: "yes", connect: "yes", firmware: "yes" },
  { id: "android", name: "Chrome on Android", platforms: "Android phones and tablets", code: "yes", connect: "yes", firmware: "no", note: "Install firmware from a computer." },
  {
    id: "linux", name: "Chrome or Chromium on Linux", platforms: "Linux", code: "yes", connect: "setting", firmware: "yes",
    note: "Turn on chrome://flags/#enable-experimental-web-platform-features, then restart the browser.",
  },
  {
    id: "brave", name: "Brave", platforms: "Windows, macOS, Linux", code: "yes", connect: "setting", firmware: "no",
    note: "Set brave://flags/#brave-web-bluetooth-api to Enabled, then restart. Install firmware with Chrome or Edge.",
  },
];

export const BROWSERS_TIP = "Your computer needs Bluetooth 4.0 or newer, switched on. School-managed laptops and Chromebooks sometimes block Bluetooth, so ask your IT team if the hub list never appears.";

export const BROWSERS_NOT = [
  { name: "Safari (Mac, iPad, iPhone)", why: "No Bluetooth for websites. You can still set up and save robots." },
  { name: "Every browser on iPhone and iPad, including Chrome and Edge", why: "Apple makes them all use Safari's engine, which has no Bluetooth for websites." },
  { name: "Firefox (all devices)", why: "No Bluetooth for websites." },
  { name: "Opera on computers", why: "Bluetooth doesn't work reliably. Use Chrome or Edge." },
];
